export default "__VITE_ASSET__YKCFZTaE__"